import { type PropsWithChildren } from 'react';

import { useTranslation } from 'react-i18next';

import { ErrorBoundary } from './ErrorBoundary';

export const ErrorBoundaryWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();
  return <ErrorBoundary t={t}>{children}</ErrorBoundary>;
};
